<template>
  <div class="support-code" v-if="!store.state.isMobile" @mouseenter="showCodeToast" @mouseleave="closeCodeToast">
    <div class="notice-box" :class="{ on: isCodeShow }">
      <img src="../../assets/img/userCenter/icon-notice.png" alt="">
      <img src="../../assets/img/userCenter/icon-notice-on.png" alt="" class="on">
    </div>
    <Transition name="fade">
      <div class="code-box" v-show="isCodeShow">
        <p class="txt">
          {{ $t("可扫描下方二维码") }}
        </p>
        <p class="txt">
          {{ $t("添加微信/LINE咨询问题") }}
        </p>
        <p class="txt">
          {{ $t("微信") }}
        </p>
        <div class="code">
          <img src="../../assets/img/userCenter/code.png" alt="">
        </div>
<!--        <p class="txt">-->
<!--          {{ $t("LINE") }}-->
<!--        </p>-->
<!--        <div class="code">-->
<!--          <img src="../../assets/img/userCenter/code.png" alt="">-->
<!--        </div>-->
<!--        <p class="txt">-->
<!--          联系电话：0411-xxxxxxxxx-->
<!--        </p>-->
<!--        <p class="txt">-->
<!--          邮箱地址：xxxxxxxxxxxxxx-->
<!--        </p>-->
      </div>
    </Transition>
  </div>
  <div class="support-code-mob" v-else>
    <div class="icon" @click="isCodeShow = true">
      <img src="../../assets/img/userCenter/icon-notice.png" alt="">
    </div>
    <Transition name="fade">
      <div class="slide-wrap" v-show="isCodeShow">
        <div class="slide">
          <p class="txt">
            {{ $t("可扫描下方二维码") }}
          </p>
          <p class="txt">
            {{ $t("添加微信/LINE咨询问题") }}
          </p>
          <p class="txt">
            {{ $t("微信") }}
          </p>
          <div class="code">
            <img src="../../assets/img/userCenter/code.png" alt="">
          </div>
<!--          <p class="txt">-->
<!--            {{ $t("LINE") }}-->
<!--          </p>-->
<!--          <div class="code">-->
<!--            <img src="../../assets/img/userCenter/code.png" alt="">-->
<!--          </div>-->
<!--          <p class="txt">-->
<!--            联系电话：0411-xxxxxxxxx-->
<!--          </p>-->
<!--          <p class="txt">-->
<!--            邮箱地址：xxxxxxxxxxxxxx-->
<!--          </p>-->
          <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="isCodeShow = false">
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const isCodeShow = ref(false);

let timer = null;
const showCodeToast = () => {
  if (timer) clearTimeout(timer);
  isCodeShow.value = true;
}

const closeCodeToast = () => {
  timer = setTimeout(() => {
    isCodeShow.value = false;
  }, 300);
}
</script>

<style>
.support-code {
  position: fixed;
  bottom: 13vw;
  right: 2.5vw;
  z-index: 500;
}

.support-code .notice-box {
  width: 3.33333vw;
  box-sizing: border-box;
  padding: 1.04166vw;
  background: #fff;
  border-radius: 0.41666vw;
  box-shadow: 0px 4px 4px 0px rgba(51, 51, 51, 0.2);
  transition: .2s all ease-out;
}

.support-code .notice-box img.on {
  display: none;
}

.support-code .notice-box.on {
  background: #B41D23;
  transition: .2s all ease-in;
}

.support-code .notice-box.on img {
  display: none;
}

.support-code .notice-box.on img.on {
  display: block;
}

.support-code .code-box {
  position: absolute;
  top: 50%;
  right: calc(100% + 0.83333vw);
  transform: translateY(-50%);
  width: 14.58333vw;
  box-sizing: border-box;
  background: #fff;
  padding: 1.25vw;
  border-radius: 0.41666vw;
  box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 0.12);
}

.support-code .code-box .txt {
  font-size: 0.83333vw;
  line-height: 1.14583vw;
  color: #2F3367;
  text-align: center;
  margin-bottom: 0.41666vw;
}

.support-code .code-box .txt:nth-of-type(2) {
  margin-bottom: 1.25vw;
}

.support-code .code-box .code {
  width: 100%;
  box-sizing: border-box;
  padding: 0 2.8125vw 1.25vw;
  border-bottom: 1px solid #D4D6D8;
  margin-bottom: 0.83333vw;
}

.support-code .code-box .txt:nth-of-type(3),
.support-code .code-box .txt:nth-of-type(4) {
  color: #8B8FA8;
}

.support-code-mob .icon {
  position: fixed;
  right: 4.4vw;
  bottom: 29.03333vw;
  width: 12.8vw;
  box-sizing: border-box;
  background: #fff;
  padding: 4vw;
  border-radius: 1.6vw;
  box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 0.12);
  z-index: 100;
}

.support-code-mob .icon img {
  width: 100%;
}

.support-code-mob .slide-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  z-index: 9999;
}

.support-code-mob .slide-wrap .slide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 74.66666vw;
  box-sizing: border-box;
  padding: 8.53333vw 6.4vw;
  border-radius: 2.13333vw;
  background: #fff;
  box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.12);
}

.support-code-mob .slide-wrap .slide .txt {
  font-size: 4.26666vw;
  line-height: 6vw;
  color: #2F3367;
  text-align: center;
  margin-bottom: 2.13333vw;
}

.support-code-mob .slide-wrap .slide .txt:last-of-type {
  margin-bottom: 0;
}

.support-code-mob .slide-wrap .slide .code {
  padding: 0 14.4vw 6.4vw;
  border-bottom: 1px solid #D4D6D8;
  margin-bottom: 4.26666vw;
}

.support-code-mob .slide-wrap .slide .close {
  position: absolute;
  top: 4.26666vw;
  right: 4.26666vw;
  width: 6.4vw;
}
</style>
